import { merge } from "lodash-es"
import React from "react"
import { Step } from "react-joyride"

function disableNext(step: Step): Step {
  return merge(step, {
    locale: {
      next: "Progress",
    },
    styles: {
      buttonNext: {
        pointerEvents: "none",
        opacity: 0.5,
        background: "#656565",
      },
    },
  })
}
const fsmCreateRouteWalkthroughSteps: Step[] = [
  disableNext({
    disableBeacon: true,
    target: "#fsm-add-route",
    content: "Click here to add a route",
    placement: "bottom",
  }),
  {
    // src/pages/fsm/routes/[id]/RouteInfo.tsx
    target: "#fsm-route-details",
    hideBackButton: true,
    placement: "left",
    content: (
      <div>
        <p className="mb-3">
          Select a survey area from the Survey Area dropdown. These are the list
          of all the survey areas from the DC selected on the top level.
        </p>
        <p>
          Enter the name of the route, its category and colour ( used for
          displaying the route on the map)
        </p>
      </div>
    ),
  },
  {
    // src/pages/fsm/routes/[id]/RouteDetailView.tsx
    target: "#fsm-outlet-list",
    placement: "left",
    content: "Select the outlets by clicking on the blue header",
  },
  disableNext({
    // src/pages/fsm/routes/[id]/OutletListFooter.tsx
    target: "#fsm-route-create-sequence-button",
    content: "Click here to create a sequence for the outlets",
    placement: "top",
  }),
  {
    // src/pages/fsm/routes/[id]/RouteDetailView.tsx
    target: "#fsm-outlet-list-header",
    placement: "left",
    content:
      "Here you can search from the selected outlets, and alter the sequence (only if Auto Arrange Outlets is disabled)",
  },
  disableNext({
    // src/pages/fsm/routes/[id]/OutletListFooter.tsx
    target: "#fsm-route-preview-button",
    placement: "top",
    content:
      "Preview route button generates the optimized directions for the trip considering outlet 1 as source and the last outlet as destination",
  }),
  {
    // src/pages/fsm/routes/[id]/RouteDetailView.tsx
    target: "#fsm-trip-info",
    content:
      "This is the total distance to be covered as well as the estimated time required for entire route. (traveling only)",
  },
  disableNext({
    // src/pages/fsm/routes/[id]/OutletListFooter.tsx
    target: "#fsm-route-save-button",
    content: "Click here to save the route",
    placement: "top",
  }),
]

export const fsmCreateBeatWalkthroughSteps: Step[] = [
  disableNext({
    // src/pages/fsm/beat/index.tsx
    disableBeacon: true,
    target: "#fsm-add-beat",
    content: "Click here to create a beat plan",
    placement: "bottom",
    spotlightClicks: true,
  }),
  {
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: "#fsm-beat-basic-form",
    offset: 1000,
    content: "Fill in the the basic details about this beat",
    hideBackButton: true,
  },
  disableNext({
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: ".fsm-beat-schedule",
    content:
      "The recurring schedule for our beat, eg. Weekly, Monthly, Twice a week etc.",
  }),
  disableNext({
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: "#add-rule",
    content: "Click here to add a rule to our schedule",
    hideBackButton: true,
    styles: {
      options: {
        zIndex: 1000,
      },
    },
  }),
  {
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: "#rule-frequency",
    hideBackButton: true,
    content: (
      <>
        <p className="mb-2">The frequency of this rule</p>
        <p>
          There are four options to choose from. Daily, Weekly, Monthly and
          Yearly along with number of repetitions
        </p>
      </>
    ),
    styles: {
      options: {
        zIndex: 1000,
      },
    },
  },
  {
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: "#rule-selection",

    content:
      "This section is for adding or removing days, months or dates from our selection. Clicking on the block will toggle the selection",
    styles: {
      options: {
        zIndex: 1000,
      },
    },
  },
  {
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: ".rule-ending",
    content:
      "Here we can specify when our schedule ends, It can either end after particular number recurrences or on a particular date",
    styles: {
      options: {
        zIndex: 1000,
      },
    },
  },
  disableNext({
    target: "#rule-save",
    content: "Click here to save the schedule",
    styles: {
      options: {
        zIndex: 1000,
      },
    },
  }),
  disableNext({
    // src/pages/fsm/beat/[id]/BeatForm.tsx
    target: "#fsm-save-beat",
    content:
      "Finally, Click here to save the beat, we will review the outlets in the next step.",
    hideBackButton: true,
  }),
  {
    target: ".vt-custom-react-table",
    hideBackButton: true,
    content:
      "These are all the outlets that are part of this beat, by default all of them are selected. To remove an outlet, simply uncheck the blue checkbox",
  },
  {
    target: "#map-list-toggle",
    content: "You can switch to map view from here to see the outlets on a map",
  },
  disableNext({
    target: "#fsm-publish-beat",
    content: "Finally publish this beat",
  }),
]

export default fsmCreateRouteWalkthroughSteps
